import { Directive, ElementRef, OnInit, Input } from '@angular/core';
@Directive({
    selector: '[userName]'
})
export class UserAvatar implements OnInit {
    @Input('userName') userName: string; // Required permission passed in

    constructor(private el: ElementRef) { }

    ngOnInit() {
        if (this.userName) {
            let arr = this.userName.split(',');
            let nameArr = this.userName.split(' ');
            let userFirstName;
            let userLastName;
            if (arr && arr.length > 1) {
                if (arr && arr.length > 0)
                    userFirstName = arr[0].trim();
                if (arr && arr.length > 1)
                    userLastName = arr[1].trim();
                this.el.nativeElement.innerHTML = userFirstName.substring(0, 1).toUpperCase( ) + userLastName.substring(0, 1).toUpperCase( );
            }
            else if (nameArr && nameArr.length > 1) {
              
                    let arrRemovedExtraSpaces=[];
                    for(let item of nameArr)
                    {
                       if(item.trim()!="")
                       arrRemovedExtraSpaces.push(item.trim());
                    }
                    if (arrRemovedExtraSpaces && arrRemovedExtraSpaces.length > 0)
                    userFirstName = arrRemovedExtraSpaces[0].trim();
                if (arrRemovedExtraSpaces && arrRemovedExtraSpaces.length > 1)
                    userLastName = arrRemovedExtraSpaces[1].trim();
                this.el.nativeElement.innerHTML = userFirstName.substring(0, 1).toUpperCase( ) + userLastName.substring(0, 1).toUpperCase( );
            }
            else {
                this.el.nativeElement.innerHTML = this.userName.substring(0, 2).toUpperCase( );
            }
        }
    }
}